import { icons } from "assets";
import React, { useState } from "react";
import { DeleteCardModal } from "Screens/account/DeleteCardModal";
import { RequestNewCardModal } from "Screens/debit-card/RequestNewCardModal";
import {
  blockUsersCard,
  requestNewCard,
  useBlockUsersCardHandler,
  useGetUsersNewCard,
} from "services/debitCardService";
import { ErrorModal } from "../successful/ErrorModal";
import { SuccessModal } from "../successful/SuccessModal";
import Text from "../text";
import styles from "./cards.module.css";

export const CardModal = ({ setVisible, cardId }) => {
  const [newCardState, setNewCardState] = useState(false);
  const [deactivateCardState, setDeactivateCardState] = useState(false);
  const [loading, setLoading] = useState(false);
  const [confirmModal, setConfirmModal] = React.useState(false);
  const [errorModal, setErrorModal] = React.useState(false);
  const [errMessage, setErrMessage] = React.useState(null);

  const handleNewCard = () => {
    setNewCardState(true);
  };

  const handleDeactivateCard = () => {
    setDeactivateCardState(true);
  };

  const requestCard = async () => {
    setLoading(true);
    try {
      const data = await requestNewCard("usd");
      console.log("DATA RETURNED ", data);
      setConfirmModal(true);
      setLoading(false);
    } catch (err) {
      setErrorModal(true);
      setLoading(false);
      setErrMessage(err.message);
      console.log(err);
    }
  };

  const blockCard = async () => {
    setLoading(true);
    try {
      const data = await blockUsersCard(cardId);
      console.log("DATA RETURNED ", data);
      setConfirmModal(true);
      setLoading(false);
    } catch (err) {
      setErrorModal(true);
      setLoading(false);
      setErrMessage(err.message);
      console.log(err);
    }
  };

  const func = () => {
    setConfirmModal(false);
    setNewCardState(false);
    setVisible(false);
  };

  console.log('CARD ID ', cardId)

  return (
    <div
      style={{
        backgroundColor: "#fff",
        width: "200px",
        position: "absolute",
        top: 60,
        borderRadius: 10,
        right: 30,
      }}
    >
      <div
        style={{
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10,
        }}
        className={styles.cardModal}
        onClick={handleNewCard}
      >
        <img src={icons.credit_card} style={{ width: 20, height: 20 }} alt="" />
        <Text style={{ paddingLeft: "1rem" }} variant="xs">
          Request New Card
        </Text>
      </div>
      <div
        style={{
          borderBottomLeftRadius: 10,
          borderBottomRightRadius: 10,
        }}
        className={styles.cardModal}
        onClick={handleDeactivateCard}
      >
        <img src={icons.deactivate} style={{ width: 20, height: 20 }} alt="" />
        <Text style={{ paddingLeft: "1rem" }} variant="xs">
          Deactivate Card
        </Text>
      </div>
      <DeleteCardModal
        deleteMessage="Are you sure about this? Deleting this debit card will affect your services payment."
        buttonText="Yes delete my card"
        deleteHeader="Confirm Delete"
        openModal={deactivateCardState}
        setOpenModal={setDeactivateCardState}
        blockCard={blockCard}
        loading={loading}
      />
      <RequestNewCardModal
        openModal={newCardState}
        setOpenModal={setNewCardState}
        requestCard={requestCard}
        loading={loading}
      />
      <SuccessModal openModal={confirmModal} func={func} />
      <ErrorModal
        message={errMessage}
        openModal={errorModal}
        setErrorModal={setErrorModal}
      />
    </div>
  );
};
